var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36627 0.21967C8.07337 -0.0732233 7.5985 -0.0732233 7.30561 0.21967C7.01271 0.512563 7.01271 0.987437 7.30561 1.28033L11.8573 5.83203H0.75C0.335786 5.83203 0 6.16782 0 6.58203C0 6.99624 0.335786 7.33203 0.75 7.33203H11.8582L7.30543 11.8878C7.01263 12.1808 7.01279 12.6557 7.30579 12.9485C7.59878 13.2413 8.07365 13.2411 8.36645 12.9481L14.1985 7.11219C14.2012 7.10948 14.2039 7.10675 14.2065 7.10401C14.4229 6.88093 14.4732 6.55665 14.3575 6.2865C14.3247 6.20998 14.2787 6.13781 14.2193 6.07351C14.2766 6.13569 14.3236 6.2076 14.3575 6.2865",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36627 0.21967L14.1959 6.04932L8.36627 0.21967Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.a535d7d018548c34d1c64e9f558da959.svg";
export { ForwardRef as ReactComponent };